import { render, staticRenderFns } from "./Play2.vue?vue&type=template&id=1cd13498&scoped=true&"
import script from "./Play2.vue?vue&type=script&lang=js&"
export * from "./Play2.vue?vue&type=script&lang=js&"
import style0 from "./Play2.vue?vue&type=style&index=0&id=1cd13498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd13498",
  null
  
)

export default component.exports